import { Observable } from 'rxjs';

export type UploadTriggerOptions = object;

export abstract class UploadSchedulerService<T = UploadTriggerOptions> {
  abstract readonly uploadTrigger$: Observable<T>;

  abstract triggerUpload(uploadTriggerOptions: T): void;
}
